export default {"src":"/_next/static/media/icon_down_arrow.a57f34c6.svg","height":30,"width":30,"blurWidth":0,"blurHeight":0};